/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GolabAppDescription } from '../../models/golab-app-description';

export interface GolabAppControllerGetGolabzAppList$Params {
}

export function golabAppControllerGetGolabzAppList(http: HttpClient, rootUrl: string, params?: GolabAppControllerGetGolabzAppList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GolabAppDescription>>> {
  const rb = new RequestBuilder(rootUrl, golabAppControllerGetGolabzAppList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GolabAppDescription>>;
    })
  );
}

golabAppControllerGetGolabzAppList.PATH = '/golab-app/golabz-app-list';
